import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { FinancesWhatToCount } from "web_myplann/Infrastructure/Translations/ResourceDictionary";

type Props = {
	category: FinancesWhatToCount["categories"][number];
};

export const WhatToCountCategoryRow: FC<Props> = ({ category }) => {
	const theme = useTheme();

	return (
		<Stack>
			<Typography variant="captionStrong" color={theme.palette.grey[800]}>
				{category.title}
			</Typography>
			<Typography variant="caption" color={theme.palette.grey[600]}>
				{category.items.join(", ")}
			</Typography>
		</Stack>
	);
};
